"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = Loading;
var _react = _interopRequireDefault(require("react"));
var _lab = require("@material-ui/lab");
var _Loading = _interopRequireDefault(require("./Loading.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function LoadingResult(_ref) {
  var _ref$half = _ref.half,
    half = _ref$half === void 0 ? false : _ref$half;
  var classes = (0, _Loading.default)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "text",
    className: classes.loadingResultTitle
  }), /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "text"
  }), /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "text"
  }), !half && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "text"
  }), /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "text"
  }), /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "text",
    className: classes.lastLine
  })));
}
function Loading() {
  var classes = (0, _Loading.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.loadingContainer
  }, /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "rect",
    className: classes.loadingTitle
  }), /*#__PURE__*/_react.default.createElement(LoadingResult, null), /*#__PURE__*/_react.default.createElement(LoadingResult, null), /*#__PURE__*/_react.default.createElement(LoadingResult, {
    half: true
  }));
}